<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-fussion"
>
  <p style="font-size: 16px; color: white">Loading...</p>
</ngx-spinner>
<app-app-loader *ngIf="isLoading"></app-app-loader>
<div class="noResults" *ngIf="!isLoading&&noSubscriptionsFlag">
    <img src="/assets/images/noResults.svg" alt="">
    <p>Looks like you haven’t created any reports yet!</p>
    <p>Go to the Data Products tab to explore all products. <br>
    </p>
    <!-- OR create a new report from here. -->
    <div class="ctaCont">
        <button class="primary" routerLink="/data-products/all" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Explore data products</button>
        <button *ngIf="false" class="primary" (click)="onSignIn()">Create New Request</button>
    </div>
</div>

<div *ngIf="!isLoading&&id && !noSubscriptionsFlag">
    <button class="primary floating" (click)="newReq()">Create New Request</button>
    <div class="filtersCont new">
        <div class="nameAndIcon" (click)="toggleFiltersCont()">
            <img src="/assets/images/newFilterIcon.svg" alt="">
            <h4 style="margin-top: 8px"> Filters
                <span *ngIf="getSelectedFilterCount() > 0">({{getSelectedFilterCount()}} selected)</span>
            </h4>

        <hr class="vertical" *ngIf="getSelectedFilterCount() > 0">
        <a (click)="resetAllFilters()" class="dmintLinkBtn redText" style="margin-top: 5px; padding: 0;"
          *ngIf="getSelectedFilterCount() > 0">
          Reset all
        </a>
        <img style="margin-left: auto;" class="" src="/assets/images/chevron-south.svg" alt="">
        </div>
         
         <form [formGroup]="dataRequestForm">
            <div class="filtersBox" *ngIf="isFilterOpen">
                <input type="search"formControlName="searchText"
                (keyup.enter)="getSearchText($event)" class="search inputField" placeholder="Search">
                <button type="button" *ngIf="dataRequestForm.get('searchText')?.value" class="clear-btn" (click)="dataRequestForm.get('searchText')?.setValue(''); onAdvancedFilter()">
                            &#x2715;
                </button>
                <!-- <div class="formControl" *ngFor="let filter of filterList">
                    <label 
                        for="{{filter.id}}"
                        class="formLabel">
                        {{filter.name}}
                    </label>
                    <input *ngIf="filter.type?.length" type="{{filter.type}}" class="inputField date" name="" id="">
                    <button 
                        class="toggleCont" 
                        (click)="showOptions(filter.id)"
                        *ngIf="filter.filterOptions"
                        >
                        <p>Select</p>
                        <img src="/assets/images/chevron-south.svg" alt="chevron-south">
                    </button>
                    <div class="optionsCont" 
                        *ngIf="isFilterOptionOpen === filter.id"
                        >
                        <label for="{{option}}" 
                            class="option" *ngFor="let option of filter.filterOptions">
                                <input type="checkbox" id="{{option}}" 
                                [checked]="isSelected(option)"
                                (change)="toggleSelection(option)">
                                <span class="styledCheckbox"></span>
                                {{option}}
                        </label>
                    </div>
                </div> -->
            
                    <div class="formControl">
                        <label  for="{{'Request Type'}}" class="formLabel">
                            {{'Request Type'}}
                        </label>
                        <div class="dropdown">
                          <ng-multiselect-dropdown
                            [placeholder]="'Select Type'"
                            [settings]="typeFilterDropdownSettings"
                            formControlName="type"
                            [data]="modulesResult"
                            (onSelect)="onTypeSelect($event)"
                            (onDeSelect)="onTypeDeselect($event)"
                            (onSelectAll)="onSelectAllTypes($event)"
                            (onDeSelectAll)="onDeSelectAllTypes()"
                            [disabled]="noSubscriptionsFlag"
                            >
                              {{ modulesResult }}
                            </ng-multiselect-dropdown>
                        </div>
                    </div>

                    <div class="formControl">
                            <label class="formLabel" for="startDate">Created on</label>
                            <mat-form-field appearance="fill">
                                <mat-date-range-input [formGroup]="createdOn" [rangePicker]="picker1"
                            [max]="maxDate">
                                    <input readonly matStartDate formControlName="startDate" placeholder="Start Date">
                                    <input readonly matEndDate formControlName="endDate" placeholder="End Date"
                                        (dateChange)="onDateSelected('created', $event)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field>
                            <div *ngIf="createdOn.errors?.['endBeforeStart']" class="error">
                                End date cannot be before start date.
                            </div>
                    </div>
                    
                    <div class="formControl">
                            <label class="formLabel" for="endDate">Updated on</label>
                            <mat-form-field>
                                <mat-date-range-input [formGroup]="modifiedOn" [rangePicker]="picker2"  [max]="maxDate">
                                    <input readonly matStartDate formControlName="startDate" placeholder="Start Date">
                                    <input readonly matEndDate formControlName="endDate" placeholder="End Date"
                                    (dateChange)="onDateSelected('updated', $event)" >
                                </mat-date-range-input>
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker2></mat-date-range-picker>
                            </mat-form-field>
                            <div *ngIf="modifiedOn.errors?.['endBeforeStart']" class="error">
                                End date cannot be before start date.
                            </div>
                    </div>
                     <div class="formControl">
                        <label  for="{{'Request Type'}}" class="formLabel">
                            {{'Status'}}
                        </label>
                       <div class="dropdown">
                            <ng-multiselect-dropdown
                                [placeholder]="'Select'"
                                [settings]="statusFilterDropdownSettings"
                                formControlName="statusType"
                                [data]="statusList"
                                (onSelect)="onStatusSelect($event)"
                                (onDeSelect)="onStatusDeselect($event)"
                                (onSelectAll)="onSelectAllStatusTypes($event)"
                                (onDeSelectAll)="onDeSelectAllStatusTypes()"
                                >
                                {{ statusList }}
                            </ng-multiselect-dropdown>
                        </div>
                    </div>
             </div>
        </form>
    </div>
    <div class="kpiCont">
      <p *ngIf="id && filterData?.length>0">
        Showing {{ (p - 1) * itemsPerPage + 1 }} -
        {{ p * itemsPerPage < totalItems ? p * itemsPerPage : totalItems }} of
        {{ totalItems }}
       </p>
       <p *ngIf="id && filterData?.length==0">Showing 0 of 0 Result</p>
    <!--  <p  *ngIf="!showCounting">
        Showing 1 of {{ filterData?.length }} Result
      </p> -->
        <div class="kpis">
            <div class="kpiItem"  [ngClass]="
              tileItems.statusName === 'NOT STARTED'
                ? 'not_started'
                : tileItems.statusName === 'IN PROGRESS'
                ? 'inProgress'
                : tileItems.statusName === 'COMPLETED'
                ? 'completed'
                : tileItems.statusName === 'FAILED'
                ? 'failed'
                : tileItems.statusName === 'DRAFT'
                ? 'draft'
                : ''
            " *ngFor="let tileItems of statusTilesData; let i = index">
                <span class="kpiLabel">{{tileItems.statusName}}</span>
                <span class="kpiValue">{{ tileItems.statusCount }}</span>
            </div>
            <hr>
            
        </div>
    </div>
    <div class="tableCont" *ngIf="id && filterData?.length>0">
        <div class="tableHead">
            <h4 style="display: flex;align-items: center;" *ngFor="let item of drmTableHeaders;let i=index">{{ item.column_name }}

                 <span 
                *ngIf="(item.column_name == 'Created On'||item.column_name == 'Last Run On') &&!noSubscriptionsFlag"
                class="down-arrow-icon"
                (click)="onSort(item.column_name,i)"
                onKeyPress=""
                [class.rotate]="isAscending && activeSortIndex==i"
              ><img
                src="../../../../assets/images//chevron-down.svg"
                alt="chevron_icon"
            /></span>
            <!-- <span *ngIf="noSubscriptionsFlag"
              class="down-arrow-icon"
              [class.rotate]="isAscendingCreated === false"
              ><img
                src="../../../../assets/images//chevron-down.svg"
                alt="chevron_icon"
            /></span> -->
            </h4>
            
        </div>
        <div class="tableBody">
            <div class="tableRow" *ngFor="let i = index; let item of filterData | paginate
                  : {
                      id: 'listing_pagination',
                      itemsPerPage: itemsPerPage,
                      currentPage: p,
                      totalItems: totalItems
                    }
            ">
                <button class="pinBtn"  (click)="togglePinned(item)"
                    [ngClass]="{ 'pinned': item.isPinned }"
                    >
                    <input *ngIf="item.isPinned" type="checkbox"
                                                [(ngModel)]="item.isPinned" class="hidden-checkbox" />
                    <img  [src]="item.isPinned
                    ? '/assets/images/pinnedReq.svg'
                    : '/assets/images/pinReq.svg'" style="height: 20px;" alt="">
                </button>
                <p>{{ item.requestId }}</p>
                <p>{{ item.productType }}</p>
                <p class="reqName" matTooltip="{{item.labelName}}">
                    {{ item.labelName }}
                </p>
                <p>{{ item.requestCreatedDate  }}</p>
                <p>{{ item.requestCompletedDate  }}</p>
                <p class="statusPill"
                      [ngClass]="{
                          'inProgress': item.statusName === 'IN PROGRESS',
                          'completed': item.statusName === 'COMPLETED',
                          'draft': item.statusName === 'DRAFT',
                          'failed':item.statusName === 'FAILED',
                          'not_started':item.statusName === 'NOT STARTED'
                      }"
                  >{{ item.statusName  }}
                  <span>
                    <ng-container *ngIf="item.statusName === 'FAILED'">
                      <img
                        onKeyPress=""
                        [src]="
                          item.statusName === 'FAILED'
                            ? '../../../../assets/images/Failed_request_icon.svg'
                            : ''
                        "
                        matTooltip="
                          {{item.statusName === 'FAILED' ||
                          item.statusName === 'IN PROGRESS'
                            ? item.failureReason
                            : ''}}
                        "
                        alt="icon"
                        class="action_icon"
                        (click)="
                          openPopup(
                            item.statusName === 'COMPLETED',
                            item.requestId,
                            item.labelName,
                            item.outputFiles,
                            item.moduleId,
                            item.requestCompletedDate
                          )
                        "
                        data-backdrop="false"
                      />
                    </ng-container>
                  </span>
                </p>
                <button class="optnsBtn" 
                    (click)="showReqOptions(i, item)" 
                    
                    [ngClass]="{'active': isRequestExpanded === item.requestId}"
                    >
                    <img src="/assets/images/kebab_default.svg" alt="Edit">
                        <div class="optnsCont" *ngIf="isRequestExpanded === item.requestId">
                        <button [disabled]="!option.actionFlag" [title]="!option.actionFlag ? option.actionMessage : ''"
                            class="option" *ngFor="let option of item.actionDetails;;"
                            (click)= "onMenuClick(item,option)">
                                <img *ngIf="getActionIcon(option.actionName)" [src]="getActionIcon(option.actionName)" [alt]="option.actionName + ' icon'">
                                {{option.actionName}}
                        </button>
                    </div>
                </button>
            </div>
        </div>
        <div class="row paginationCont" *ngIf="id && filterData?.length > 0">
            <pagination-controls id="listing_pagination"
            [maxSize]="5" 
                (pageChange)="getPage($event)"
                previousLabel="Prev"
                nextLabel="Next">
            </pagination-controls>
        </div>
    </div>
      <ng-container *ngIf="id && filterData?.length === 0 && noSubscriptionsFlag === false">
        <div class="noResults">
            <img src="/assets/images/noResults.png" alt="no-results" />
            <p>No results found.</p>
        </div>
      </ng-container>
   
     <!-- Modal window container starts -->
    <div
      class="modal modal-backdrop download-popup"
      *ngIf="isDownloadPopupVisibale"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: displayStyle }"
    >
      <div class="modal-dialog" role="document">
        <div class="overlay" *ngIf="isOpenOverlayScreen">
          <div
            class="close_icon_overlay"
            (click)="closeOverlayPopup()"
            onKeyPress=""
          >
            <img
              src="../../../../assets/images/close_icon.svg"
              class="close_icon"
              width="16px"
              height="16px"
              alt="icon"
            />
          </div>
          <div class="text">
            {{ loginAlertMessage }}
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">Download Files</div>
            <div (click)="closePopup()" onKeyPress="">
              <img
                src="../../../../assets/images/close_icon.svg"
                class="close_icon"
                width="16px"
                height="16px"
                alt="icon"
              />
            </div>
          </div>
          <div class="modal-body">
            <div class="table_details_div">
              <div class="table_details">
                <span class="table_details_title">Request ID:</span
                ><span class="table_details_text">{{ getRequestId }}</span>
              </div>
              <div class="table_details">
                <span class="table_details_title">Label:</span
                ><span class="table_details_text">{{ downloadFileLabel }}</span>
              </div>
            </div>
            <div class="modal_table_div">
              <table  aria-hidden="true" class="table table-striped modal_table">
                <tbody>
                  <tr *ngFor="let fileName of downloadFileName">
                    <td>
                      <span
                        ><img
                          src="../../../../assets/images/file_icon.svg"
                          alt="file_icon"
                          class="file_icon"
                          width="24px"
                          height="24px" /></span
                      ><span>{{ fileName.displayFileName }}</span>
                    </td>
                    <td>
                      Size: {{ fileName.fileSize | formatFileSize : true }} |
                      Last updated:
                      {{ requestCompletedDate | date : 'dd MMM yyyy' }}
                    </td>
                    <td>
                      <img
                        src="../../../../assets/images/download_action.svg"
                        alt="icon"
                        class="download_icon"
                        onKeyPress=""
                        (click)="onDownload(fileName.fileName)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal window container ends -->


    
    <div class="popUpCont" [ngClass]="{ 'dontShow' : !showDeletepopup }">
        <div class="modalCont">
            <div class="modalHead">
                <h1>Are you sure?</h1>
                <button class="iconBtn noBorder" (click)="onClosePopup()"><img src="/assets/images/closeIcon-16x16.svg" alt="" ></button>
            </div>
            <div class="modalContent">
                <p>
                    You are about to delete this request. Once deleted, it cannot be recovered.
                </p>
                <p>
                    Do you want to proceed?
                </p>
            </div>
            <div class="modalFoot">
                <!-- <button class="secondary">Cancel</button> -->
                <button class="primary red"  (click)="onDeleteRequest(storeRequestId)">Yes, Delete</button>
            </div>
        </div>
    </div>

</div>

<div class="popUpCont" [ngClass]="{ 'dontShow' : !showNewRequestsPopup }">
    <div class="modalCont" style="width: auto;">
        <div class="modalHead">
            <h3 style="margin: 0;">Select a Data Product to begin</h3>
            <button class="iconBtn noBorder" (click)="newReq()"><img src="/assets/images/closeIcon-16x16.svg" alt=""></button>
        </div>
        <div class="modalContent" style="width: 100%;">
            <div class="productsGrid">
                <div class="product" style="cursor: pointer;" *ngFor="let module of modulesResult"
                (click)="module.createAction?goToLink(module.moduleLink):null" [ngClass]="module.createAction?'':'disabled'">
                <div class="moduleImage">   
                 <img [src]="moduleByteMap[module.moduleName] || moduleByteMap['Tyre Pairing'] | base64 : 'image/png'" alt="{{ module.moduleName }}">
                </div>   
                <h4>{{ module.moduleName }}</h4>
                </div>
            </div>
        </div>
    </div>
</div>

<app-success-toast
  [message]="successMessage"
  *ngIf="successMessage"
></app-success-toast>

<app-error-toast
  [message]="errMsgText"
  *ngIf="errMsgText && flagError"
></app-error-toast>
<app-alert
  [message]="errMsgPopup"
  *ngIf="showErrorMessageWithPopup"
  (close)="onCloseHandler()"
></app-alert>